import styled from '@emotion/styled';
import moment from 'moment';
import { useState } from 'react';
import { SingleDatePicker } from 'react-dates';
import { Button, Modal } from 'semantic-ui-react';
import { renderMonthElement } from 'src/components/form/Form';
import Swal from 'sweetalert2';

const RequestAnswersModal = styled('div')`
  p {
    margin: 0;
  }
  .approval,
  .date {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 20px 0;
  }
  .date-picker,
  .actions {
    display: flex;
    flex-direction: row;
    justify-content: end;
    button {
      margin: 0 10px;
    }
  }
`;

const WeddingRequestFacilitatorAnswersModal = (props) => {
  const {
    inputs,
    set_inputs,
    editAnswerVars,
    facilitator_editing,
    loading,
    set_facilitator_editing,
    answers,
  } = props;
  const [dateFocused, set_dateFocused] = useState(null);

  const handleInputs = (event) => {
    let value = event.target.value;
    let name = event.target.name;
    set_inputs({ ...inputs, [name]: value });
  };

  const onClose = () => {
    set_facilitator_editing(false);
  };

  const rejectWeddingRequest = async () => {
    const { value: text } = await Swal.fire({
      title: `¿Seguro que desea no aprobar la solicitud de matrimonio?`,
      text: `Escribe la razón para no aprobar la solicitud de matrimonio de ${answers?.MaleGuest?.name} y ${answers?.FemaleGuest?.name}`,
      input: 'text',
      inputPlaceholder: 'Escribe la razón',
      inputAttributes: {
        'aria-label': 'razon',
      },
      showCancelButton: true,
    });
    if (text) {
      editAnswerVars('approved', text);
    }
  };

  const acceptWeddingRequest = async () => {
    Swal.fire({
      title: 'Enviar aprobación',
      text: `Desea aprobar la solicitud de matrimonio de ${answers?.MaleGuest?.name} y ${answers?.FemaleGuest?.name}`,
      showCancelButton: true,
      confirmButtonText: 'Si, aprobar',
      cancelButtonText: 'Volver',
    }).then((result) => {
      if (result.value) {
        editAnswerVars('approved', 'Aprobado');
      }
    });
  };

  const checkDateRange = (day) => {
    return false;
    //day.isAfter(moment(answers.createdAt).add(15, 'days')) ||      day.isBefore(moment().subtract(12, 'hours'));
  };

  const sendDate = () => {
    if (!inputs?.date || checkDateRange(moment(inputs?.date)))
      return Swal.fire({
        icon: 'error',
        title: 'Error',
        text: `La fecha debe ser valida ${
          inputs?.date && checkDateRange(moment(inputs?.date))
            ? 'y máximo 15 días después de la solicitud'
            : ''
        }`,
      });
    editAnswerVars('date', inputs?.date);
  };

  return (
    <>
      <Button
        onClick={() => {
          set_facilitator_editing(true);
        }}
        primary
      >
        Editar
      </Button>
      <Modal size={'small'} open={facilitator_editing} onClose={onClose}>
        <Modal.Header>Editar</Modal.Header>
        <Modal.Content>
          <RequestAnswersModal>
            <div className="date">
              <div className="info">
                Cita:
                <p>
                  <strong>
                    {answers?.facilitatorObservations?.date
                      ? moment
                          .tz(answers?.facilitatorObservations?.date, 'America/Bogota')
                          .format('DD-MM-YYYY')
                      : 'Sin cita'}
                  </strong>
                </p>
              </div>
              <div className="date-picker">
                <div>
                  {!!answers?.facilitatorObservations?.date && <p>Cambiar:</p>}
                  <SingleDatePicker
                    date={
                      new Date(inputs?.date) === 'Invalid Date' || !inputs?.date
                        ? null
                        : moment(inputs?.date)
                    }
                    onDateChange={(newDate) =>
                      handleInputs({
                        target: {
                          value: newDate ? newDate._d : newDate,
                          name: 'date',
                        },
                      })
                    }
                    focused={dateFocused === 'date'}
                    onFocusChange={({ focused }) => set_dateFocused(focused ? 'date' : null)}
                    placeholder="dd/mm/aaaa"
                    showDefaultInputIcon={true}
                    numberOfMonths={1}
                    displayFormat="DD/MM/YYYY"
                    isOutsideRange={checkDateRange}
                    id={'date'}
                    renderMonthElement={renderMonthElement}
                  />
                  <Button onClick={sendDate} primary>
                    Enviar fecha
                  </Button>
                </div>
              </div>
            </div>
            <div className="approval">
              <div className="info">
                Aprobación del facilitador:{' '}
                <p>
                  <strong>
                    {answers?.facilitatorObservations?.approved === undefined
                      ? 'Sin responder'
                      : answers?.facilitatorObservations?.approved === 'Aprobado'
                      ? answers?.facilitatorObservations?.approved
                      : 'No: ' + answers?.facilitatorObservations?.approved}
                  </strong>
                </p>
              </div>
              <div className="actions">
                <div>
                  {!!answers?.facilitatorObservations?.approved && <p>Cambiar:</p>}
                  <Button onClick={acceptWeddingRequest} disabled={loading}>
                    Aprobar
                  </Button>
                  <Button onClick={rejectWeddingRequest} disabled={loading}>
                    Rechazar
                  </Button>
                </div>
              </div>
            </div>
          </RequestAnswersModal>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={onClose} negative>
            Volver
          </Button>
        </Modal.Actions>
      </Modal>
    </>
  );
};

export default WeddingRequestFacilitatorAnswersModal;
